// extracted by mini-css-extract-plugin
export default {"container":"Layout_container__7gXvt","loadingSpinner":"Layout_loadingSpinner__tFRcb"};